import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  declare readonly inputTarget: HTMLInputElement
  timeout: number | undefined

  submit (): void {
    clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => {
      this.performSearch()
    }, 200)
  }

  clearSearch (): void {
    this.inputTarget.value = ''
    this.performSearch()
  }

  private performSearch (): void {
    const form = this.element as HTMLFormElement
    const url = form.action
    const formData = new FormData(form)
    const params = new URLSearchParams(formData as any).toString()
    fetch(`${url}?${params}`, {
      headers: { Accept: 'text/vnd.turbo-stream.html' }
    })
      .then(async (response) => await response.text())
      .then((html) => {
        // @ts-expect-error
        Turbo.renderStreamMessage(html)
      })
      .catch(() => {})
  }
}
